import { useState } from 'react';
import { getCurrentPermissions } from '../Authentication/AuthorisationAsync';
import { AuthState } from '../Authentication/AuthorisationModels';
import { getMedicationsPermissions, setMedicationsPermissions } from '../Config/PermissionConfig';
import { MedicationsPermissions } from '../MedicationsPermissions';

export function isUserAuthorised(code: MedicationsPermissions | MedicationsPermissions[]): boolean {
    if (Array.isArray(code)) {
        let isAuthorised = true;

        code.forEach(targetCode => {
            const permissionState = getMedicationsPermissions().find(it => it.definitionCode === targetCode);
            if (permissionState) {
                if (permissionState.state !== AuthState.Allowed) isAuthorised = false;
            } else {
                isAuthorised = false;
                console.warn('Unknown permission code requested - code: ', code);
            }
        });

        return isAuthorised;
    } else {
        const permissionState = getMedicationsPermissions().find(it => it.definitionCode === code);
        if (permissionState) return permissionState.state === AuthState.Allowed;
    }

    console.warn('Unknown permission code requested - code: ', code);
    return false;
}

export enum LoadingStatus {
    Loading = 'Loading',
    Loaded = 'Loaded',
    Error = 'Error'
}

export function usePermissionLoader() {
    const [permissionStatus, setPermissionStatus] = useState<LoadingStatus>(LoadingStatus.Loading);

    async function loadPermissions() {
        try {
            const permissions = await getCurrentPermissions();
            setMedicationsPermissions(permissions);
            setPermissionStatus(LoadingStatus.Loaded);
        } catch (err) {
            setPermissionStatus(LoadingStatus.Error);
        }
    }

    return {
        permissionStatus,
        loadPermissions
    };
}
